var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5025 4.44453C11.5025 2.9104 12.7519 1.66675 14.293 1.66675C15.834 1.66675 17.0834 2.9104 17.0834 4.44453C17.0834 5.97865 15.834 7.2223 14.293 7.2223C13.5148 7.2223 12.8115 6.90505 12.3059 6.39464L8.44307 9.02471C8.47879 9.20215 8.4975 9.38546 8.4975 9.57273C8.4975 9.94359 8.42422 10.2981 8.29135 10.6221L12.527 13.4049C13.0076 13.0135 13.6228 12.7779 14.293 12.7779C15.834 12.7779 17.0834 14.0215 17.0834 15.5556C17.0834 17.0898 15.834 18.3334 14.293 18.3334C12.7519 18.3334 11.5025 17.0898 11.5025 15.5556C11.5025 15.1538 11.5886 14.7713 11.7431 14.426L7.54174 11.6657C7.05165 12.0916 6.40969 12.3505 5.70709 12.3505C4.16599 12.3505 2.91669 11.1069 2.91669 9.57273C2.91669 8.03861 4.16599 6.79495 5.70709 6.79495C6.59327 6.79495 7.38213 7.20613 7.89289 7.84606L11.6366 5.2971C11.5495 5.02808 11.5025 4.74141 11.5025 4.44453Z",
    fill: "#00A991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.a8f1985f324353e68f105c922b5ffeca.svg";
export { ForwardRef as ReactComponent };